import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Tv = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <path d="M8.001 5.038a.333.333 0 0 1-.266-.133l-2-2.667a.333.333 0 1 1 .533-.4l2 2.667A.333.333 0 0 1 8 5.038Z" />
      <path d="M8.001 5.037a.333.333 0 0 1-.256-.546l3.333-4a.334.334 0 0 1 .512.427l-3.333 4a.333.333 0 0 1-.256.12Z" />
      <path d="M14 15.704H2a1.669 1.669 0 0 1-1.666-1.667v-8a1.669 1.669 0 0 1 1.667-1.666h12a1.669 1.669 0 0 1 1.666 1.667v8A1.668 1.668 0 0 1 14 15.703ZM2 5.038a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1H2Z" />
      <path d="M2.667 6.371h8.667a.333.333 0 0 1 .333.333v6.667a.333.333 0 0 1-.333.333H2.667a.333.333 0 0 1-.333-.333V6.704a.333.333 0 0 1 .333-.333Zm8.334.667H3v6h8v-6ZM13.333 7.704A.333.333 0 0 1 13 7.371v-.667a.333.333 0 1 1 .667 0v.667a.333.333 0 0 1-.334.333ZM13.333 13.703A.333.333 0 0 1 13 13.37v-3.334a.333.333 0 0 1 .667 0v3.334a.333.333 0 0 1-.334.333Z" />
    </svg>
  );
};

Tv.category = 'product-category';

Tv.displayName = 'Tv';
